import { TableCell, TableRow } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { useUpdateUserContactStatuses } from '../../../../sic-lib/api/hooks/useUserContactStatuses';
import { buildCreateContactStatus } from '../../../../sic-lib/types/ContactStats';
import { ContactStatus } from '../../../../sic-lib/types/ContactStatus';
import EditButtonGroup from '../../../Shared/FormControls/Buttons/EditButtonGroup';

interface Props {
    status: ContactStatus;
    onToggleHandler: () => void;
}

export default function ContactStatusEdit({ status, onToggleHandler }: Props) {
    const { mutate: updateUserContactStatusesMutation, isLoading: isUpdateLoading } =
        useUpdateUserContactStatuses();

    const [nextStatus, setNextStatus] = React.useState<ContactStatus>(status);

    const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setNextStatus(prev => ({ ...prev, status: event.target.value }));
    };

    const handleSave = async () => {
        const newStatus = buildCreateContactStatus({
            statusId: nextStatus.statusId,
            status: nextStatus.status,
        });

        updateUserContactStatusesMutation(newStatus);

        onToggleHandler();
    };

    return (
        <ClickAwayListener onClickAway={onToggleHandler}>
            <TableRow>
                <TableCell>
                    <TextField
                        id="statusId"
                        label="Status"
                        name="Status"
                        value={nextStatus.status}
                        onChange={handleChange}
                        autoFocus
                        required
                    />
                </TableCell>
                <TableCell>
                    <Grid container flexDirection="row" justifyContent="flex-end">
                        <Grid item>
                            <EditButtonGroup
                                onSave={handleSave}
                                onCancel={onToggleHandler}
                                allowDelete={false}
                                size="small"
                            />
                        </Grid>
                    </Grid>
                </TableCell>
            </TableRow>
        </ClickAwayListener>
    );
}
